<template>
  <CSelect
    class="w-auto flex flex-col gap-2 relative -top-1 max-h-[180px] overflow-y-auto"
    :consistent-menu-width="false"
    :options="fontOptions"
    placement="bottom-start"
    :render-label="renderLabel"
    :value="modelValue"
    @update:value="$emit('update:modelValue', $event)"
  />
</template>

<script lang="ts" setup>
import type { SelectBaseOption } from 'naive-ui/es/select/src/interface'
import { onMounted, ref, h } from 'vue'
import { orderBy } from 'lodash-es'

import useCanvasTheme from '@lib/apps/canvas-builder/composables/useCanvasTheme'
import CSelect from '@lib/components/CSelect/CSelect.vue'
import { DEFAULT_FONT } from '@canvas-builder/constants'

const props = withDefaults(
  defineProps<{
    modelValue?: string
    renderFontPreview?: boolean
  }>(),
  {
    renderFontPreview: false,
  },
)

defineEmits<{
  'update:modelValue': [value: string]
}>()

const { customFonts } = useCanvasTheme()

const fontOptions = ref<SelectBaseOption<string, string>[]>([{ label: DEFAULT_FONT, value: DEFAULT_FONT }])

function renderLabel(option: SelectBaseOption<string, string>) {
  return h('div', {}, [
    h(
      'span',
      props.renderFontPreview
        ? {
            style: { fontFamily: option.value },
          }
        : {},
      option.label,
    ),
  ])
}

onMounted(async () => {
  if (customFonts.value?.length) {
    fontOptions.value = orderBy(
      [
        ...fontOptions.value,
        ...customFonts.value.map((item) => ({
          value: item.name ?? '',
          label: item.name ?? '',
        })),
      ],
      ['label'],
    )
  }
})
</script>
